import { AllLang, Language } from "../interface/CommonTypes";

const htmlEl = document.getElementsByTagName("html")[0];
let lang = htmlEl.getAttribute('lang')?.toLocaleLowerCase();
if (!lang) lang = 'ko';

const allLang: AllLang = {
    ko : {
        noresult: '선택 조건에 결과가 없습니다.',
        year: '{n}년',
        allserver: '서버전체',
        allyear: '연도전체'
    },
    zh : {
        noresult: '選擇的條件無對應結果。',
        year: '{n}年',
        allserver: '全伺服器',
        allyear: '全年度'
    },
    ja : {
        noresult: '選択条件の結果がありません。',
        year: '{n}年',
        allserver: 'サーバー全体',
        allyear: '年度全体'

    },
    en : {
        noresult: 'No search results with the selected conditions.',
        year: '{n}',
        allserver: 'All Servers',
        allyear: 'All Years'
    },
    th : {
        noresult: 'ไม่พบผลการค้นหาในเงื่อนไขการเลือก',
        year: 'ปี {n}',
        allserver: 'เซิร์ฟเวอร์ทั้งหมด',
        allyear: 'ปีทั้งหมด'
    },
    ru : {
        noresult: 'По заданным критериям ничего не найдено.',
        year: '{n} г.',
        allserver: 'Все сервера',
        allyear: 'Все года'
    },
    id : {
        noresult: 'Tidak ada hasil yang sesuai dengan kriteria yang dipilih.',
        year: '{n}',
        allserver: 'Semua Server',
        allyear: 'Semua Tahun'
    },
    ar : {
        noresult: 'لا توجد نتائج في معايير الاختيار.',
        year: 'سنة {n}',
        allserver: 'الخادم الكلي',
        allyear: 'السنة كاملة'
    }
};

export default allLang[lang];
/* 
let output: Language = { noresult: '', year: '', allserver: '', allyear: '' };
Object.keys(allLang).forEach( key=>{
    if (key===lang) {
        output = allLang[key];
    }
});

export default output; */